var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImg = function SvgImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#21852B",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.25 13.5v4h-.846v-4zm.86 0h1.043l1.102 2.688h.047l1.101-2.688h1.043v4h-.82v-2.604h-.034L9.558 17.48H9l-1.035-2.593H7.93V17.5h-.82zm7.85 1.293a.9.9 0 0 0-.115-.252.778.778 0 0 0-.424-.307 1 1 0 0 0-.299-.04.96.96 0 0 0-.539.152 1 1 0 0 0-.36.443 1.7 1.7 0 0 0-.128.707q0 .418.127.711a1 1 0 0 0 .36.447 1 1 0 0 0 .548.153q.287 0 .49-.102a.73.73 0 0 0 .313-.29.87.87 0 0 0 .11-.444l.171.025h-1.031v-.637h1.674v.504q0 .528-.223.907a1.5 1.5 0 0 1-.613.582 1.9 1.9 0 0 1-.895.203q-.562 0-.988-.248a1.7 1.7 0 0 1-.664-.71q-.236-.46-.236-1.093 0-.486.14-.867.143-.383.399-.649.255-.266.595-.404.34-.139.737-.139.34 0 .632.1.294.098.52.277.228.18.373.428.144.246.185.543z"
  })));
};
export default SvgImg;